import AWS from 'aws-sdk';

const awsConfig = () => {
  AWS.config.update({
    region: process.env.REACT_APP_S3_BUCKET_REGION,
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    }),
  });
};

export default awsConfig;
